import { type StopType } from 'core/domain/StopType'

import { Container, Timeline, Line, Dot, Content } from './TimelineItem.styles'

export type TimelineItemProps = {
  children?: React.ReactNode
  type: StopType
}

export function TimelineItem({ children, type }: TimelineItemProps) {
  return (
    <Container>
      <Timeline type={type}>
        <Line type={type}>
          <Dot />
        </Line>
      </Timeline>
      <Content>{children}</Content>
    </Container>
  )
}
